import Consts from '../../consts/clientConsts'

export default class {

    Id = null;

    Name = null;

    Type = null;

    Status = null;   

    Comment = null;

    Creator = null;

    TemplateName = null;

    SendDate = null;

    CompletionLocation = null;

    CreationLocation = null;

    FormList = [];    

    IsOngoing = false;
    IsCompleted = false;
    IsCanBeCompleted = false;

    mapFromDto(auditDto) {
        if(!auditDto)
            return this;
        
        this.Id = auditDto.Id;
        this.Name = auditDto.Name;
        this.Type = Consts.AuditType.find(e => e.Id == auditDto.Type);
        this.Status = Consts.AuditStatus.find(e => e.Id == auditDto.Status);
        this.Comment = auditDto.Comment;
        this.Creator = auditDto.Creator;
        this.TemplateName = auditDto.TemplateName;
        this.SendDate = new Date(auditDto.SendDate);
        this.CompletionLocation = auditDto.CompletionLocation;
        this.CreationLocation = auditDto.CreationLocation;

        this.IsOngoing = auditDto.Status == 1;
        this.IsCompleted = auditDto.Status == 2;
        this.IsCanBeCompleted = auditDto.IsCanBeCompleted;

        if(auditDto.FormList && auditDto.FormList.length)
            this.FormList = auditDto.FormList.map(e => new AuditForm().mapFromDto(e));

        return this;
    }
}

class AuditForm {

    Id = null;
    Name = null;    
    Address = null;
    
    Status = null;
    ImagePath = null;

    ContainsTt = null;

    Comment = null;

    CreationDate = null;

    CompletionDate = null;

    CompletionLocation = null

    CreationLocation = null;

    mapFromDto(auditFormDto) {

        this.Id = auditFormDto.Id;
        this.Name = auditFormDto.Name ? auditFormDto.Name : "Не синхронизированно";
        this.Address = auditFormDto.Name ? auditFormDto.Address : "Не синхронизированно";

        this.ContainsTt = auditFormDto.ContainsTt;

        this.Status = Consts.FormStatus.find(e => e.Id == auditFormDto.Status);
        this.ImagePath = `/img/check-${this.Status.Text}.png`;

        this.Comment = auditFormDto.Comment;
        this.CreationDate = new Date(auditFormDto.CreationDate);
        this.CompletionDate = new Date(auditFormDto.CompletionDate);
        this.CompletionLocation = auditFormDto.CompletionLocation;
        this.CreationLocation = auditFormDto.CreationLocation;

        return this;
    }
}